import { render, staticRenderFns } from "./esd-safe.vue?vue&type=template&id=4e4978e6&"
import script from "./esd-safe.vue?vue&type=script&lang=js&"
export * from "./esd-safe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports